import MenuIcon from "@mui/icons-material/Menu";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Container from "@mui/material/Container";
import IconButton from "@mui/material/IconButton";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import * as React from "react";
import { useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import useIsAdmin from "../../app/useIsAdmin";
import thuthukaLogo from "../../assets/images/thuthukaLogoVectorHeader.svg";
import { selectLogin } from "../../features/login/loginSlice";
import NotificationsPanel from "./NotificationsPanel";
import SettingsMenu from "./SettingsMenu";
import { fetchNotificationsThunk } from "../../features/admin/thunks";

const pages = [
  { name: "Dashboard", url: "dashboard" },
  { name: "Applications", url: `applications/${new Date().getFullYear()}` },
  { name: "Assessment Audits", url: "assessments-audits" },
];

function ResponsiveAppBar() {
  const [anchorElNav, setAnchorElNav] = React.useState<null | HTMLElement>(
    null
  );

  const adminlogin = useAppSelector(selectLogin);
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const handleOpenNavMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorElNav(event.currentTarget);
  };

  const handleCloseNavMenu = (e: any, url: string) => {
    setAnchorElNav(null);
    if (url && url !== "backdropClick") navigate(`/${url}`);
  };

  const renderDisplayName = () => {
    if (adminlogin.loginState.login)
      return `Hello, ${adminlogin.loginState.login.displayName}`;
    else return "";
  };

  React.useEffect(() => {
    renderDisplayName();
  }, [adminlogin.loginState.login]);

  React.useEffect(()=>{
    dispatch(fetchNotificationsThunk())
  },[])
  
  useIsAdmin();

  return (
    <AppBar
      position="static"
      sx={{
        flexGrow: 1,
        backgroundColor: "#0B264F",
        color: "#fff",
        paddingLeft: "9%",
        paddingRight: "9%",
        borderBottom: "1px solid rgba(0, 0, 0, 0.05)",
        boxShadow: "none",
        top: 0,
        left: 0,
        right: 0,
        position: "fixed",
        zIndex: 99,
      }}
    >
      <Container maxWidth="xl">
        <Toolbar disableGutters>
          <Box
            component="span"
            sx={{
              display: { xs: "none", md: "flex" },
              mr: 5,
              height: 50,
              width: 50,
            }}
          >
            <img src={thuthukaLogo} alt="logo" width={50} height={50} />
          </Box>

          <Box sx={{ flexGrow: 1, display: { xs: "flex", md: "none" } }}>
            <IconButton
              size="large"
              aria-label="account of current user"
              aria-controls="menu-appbar"
              aria-haspopup="true"
              onClick={handleOpenNavMenu}
              color="inherit"
            >
              <MenuIcon />
            </IconButton>
            <Menu
              id="menu-appbar"
              anchorEl={anchorElNav}
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "left",
              }}
              keepMounted
              transformOrigin={{
                vertical: "top",
                horizontal: "left",
              }}
              open={Boolean(anchorElNav)}
              onClose={(e) => handleCloseNavMenu(e, "#")}
              sx={{ display: { xs: "block", md: "none" } }}
            >
              {pages.map((page) => (
                <MenuItem
                  key={page.name}
                  onClick={(e) => handleCloseNavMenu(e, page.url)}
                >
                  <Typography sx={{ textAlign: "center" }}>
                    {page.name}
                  </Typography>
                </MenuItem>
              ))}
            </Menu>
          </Box>
          <Box
            component="span"
            sx={{
              display: { xs: "flex", md: "none" },
              mr: 1,
              height: 50,
              width: 50,
            }}
          >
            <img src={thuthukaLogo} alt="Logo" height="100%" width="100%" />
          </Box>

          <Box sx={{ flexGrow: 1, display: { xs: "none", md: "flex" } }}>
            {pages.map((page) => (
              <Button
                key={page.name}
                onClick={(e) => handleCloseNavMenu(e, page.url)}
                sx={{ my: 2, color: "white", display: "block" }}
              >
                {page.name}
              </Button>
            ))}
          </Box>
          <Box sx={{ flexGrow: 0, display:'flex', justifyContent:'space-between'}}>
            <NotificationsPanel/>
            <SettingsMenu />
            {renderDisplayName()}
          </Box>
        </Toolbar>
      </Container>
    </AppBar>
  );
}
export default ResponsiveAppBar;
